module.exports = __webpack_public_path__ + "static/media/award_icon.84645d86.JPG";